import { render } from "./CommentsView.vue?vue&type=template&id=2aad8224"
import script from "./CommentsView.vue?vue&type=script&lang=js"
export * from "./CommentsView.vue?vue&type=script&lang=js"

import "./CommentsView.vue?vue&type=style&index=0&id=2aad8224&lang=css"

import exportComponent from "/Users/terrencewong/ispeech/ispeech-web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__